import { styled } from '@abyss/web/tools/styled';
import { Box } from '@abyss/web/ui/Box';
import { Flex } from '@abyss/web/ui/Flex';
import { Heading } from '@abyss/web/ui/Heading';
import { Text } from '@abyss/web/ui/Text';
import { useRouter } from 'next/compat/router';
import { Button } from '@pass-frontend/abyss/common/components/button/ui';
import { ContentWidthWrapper } from '@pass-frontend/abyss/common/components/content-width-wrapper/ui';
import { MEDIA_QUERY } from '@pass-frontend/abyss/utility/style-helpers';
import {
  EventType,
  getPageName,
  logAnalyticsEvent,
} from '@pass-frontend/common/analytics';
import { getRegistrationUrl } from '@pass-frontend/common/constants/paths';
import { useIntl } from '@pass-frontend/common/i18n';

const StyledWrapper = styled(Flex, {
  padding: '$lg 0',

  [MEDIA_QUERY.desktop]: {
    padding: '64px 0',
  },
});

const StyledImage = styled('img', {
  marginBottom: '64px',
  height: '400px',

  [MEDIA_QUERY.mobileAndTablet]: {
    marginBottom: '32px',
    height: '184px',
  },
});

const StyledHeading = styled(Heading, {
  marginBottom: '$md',

  [MEDIA_QUERY.desktop]: {
    marginBottom: '$lg',
  },
});

const StyledDescription = styled(Text, {
  marginBottom: '$md',

  [MEDIA_QUERY.desktop]: {
    marginBottom: '32px',
  },
});

const StyledButton = styled(Button, {
  [MEDIA_QUERY.mobileAndTablet]: {
    width: '100%',
  },
});

export function HeroComponent({ isCommercial }: { isCommercial?: boolean }) {
  const { t } = useIntl();
  const router = useRouter();

  const handleGetStartedButtonClick = (e) => {
    logAnalyticsEvent(
      EventType.PageNav,
      {
        pageName: getPageName(router?.pathname),
      },
      e.nativeEvent,
    );
    router?.push(getRegistrationUrl(router?.locale));
  };

  return (
    <Box color="$primary4" padding="0">
      <ContentWidthWrapper>
        <StyledWrapper justify="center">
          <Flex
            direction="column"
            alignItems="center"
            css={{ maxWidth: '700px' }}
          >
            <StyledImage
              src={
                isCommercial
                  ? 'images/gym-members-activities.png'
                  : 'images/hero.jpg'
              }
              alt={
                isCommercial ? t('hero.imgAlt') : t('hero.government.imgAlt')
              }
            />
            <StyledHeading offset={0} textAlign="center">
              {t('hero.heading')}
            </StyledHeading>
            <StyledDescription size="$lg" css={{ textAlign: 'center' }}>
              {t('hero.description')}
            </StyledDescription>
            <StyledButton
              onClick={handleGetStartedButtonClick}
              data-ui-element-name="hero-component-get-started-btn"
            >
              {t('hero.cta')}
            </StyledButton>
          </Flex>
        </StyledWrapper>
      </ContentWidthWrapper>
    </Box>
  );
}
